var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 125",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4305e-6 -17.438)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 129.94 129.94)",
    strokeWidth: 1.2346
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -85.185,
    y: 48.16,
    width: 85.185,
    height: 24.691
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -85.185,
    y: 87.025,
    width: 45.679,
    height: 24.691
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -100,
    y: 34.877,
    width: 8.642,
    height: 90.123
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignTop);
export default __webpack_public_path__ + "static/media/align-top.19d696c2e541483699d4c2d063d154c8.svg";
export { ForwardRef as ReactComponent };